module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-9.08989dee.png";